import { render } from "./RelProdutosPorDataTable.vue?vue&type=template&id=14d4dcaa"
import script from "./RelProdutosPorDataTable.vue?vue&type=script&lang=js"
export * from "./RelProdutosPorDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__